<template>
    <b-form-input :placeholder="$t('questionnaire.answer')" type="text" class="apprentice-input-field with-border" v-model="text" @input="updateAnswer"></b-form-input>
</template>

<script>

    export default {
        name: 'design-2021-questionnaire-answer-component',
        props: ['value'],
        data() {
            return {
                text: this.value,
            }
        },

        methods: {
            updateAnswer() {
                this.$emit('input', this.text);
            }
        }
    }

</script>

<style scoped lang="scss">
    input {
        border: 1px solid $border-color;
    }
</style>
